import { useMemo } from 'react';
import { useMatch } from 'react-router-dom';

import { pathToRegexp } from 'path-to-regexp';

import { AppRoutePath, NOT_FOUND_CASE_ID } from 'config/constants';
import { getWARDCaseId } from 'domains/viewer/Viewer/Ward/utils';

export const extractWorklistIds = (path: string): string[] => {
  const viewerKeys: Array<any> = [];
  const viewerRegexp = pathToRegexp(AppRoutePath.VIEWER, viewerKeys);
  const viewerMatch = viewerRegexp.exec(path);

  const viewerId = viewerMatch?.[viewerKeys.findIndex((k) => k.name === 'worklistId') + 1];

  const reporterKeys: Array<any> = [];
  const reporterRegexp = pathToRegexp(AppRoutePath.REPORTER, reporterKeys, { end: false });
  const reporterMatch = reporterRegexp.exec(path);
  const reporterId = reporterMatch?.[reporterKeys.findIndex((k) => k.name === 'worklistId') + 1];

  const undockedPatientJacketKeys: Array<any> = [];
  const undockedPatientJacketRegexp = pathToRegexp(
    AppRoutePath.PATIENT_JACKET_UNDOCKED,
    undockedPatientJacketKeys
  );
  const undockedPatientJacketMatch = undockedPatientJacketRegexp.exec(path);
  const undockedPatientJacketId =
    undockedPatientJacketMatch?.[undockedPatientJacketKeys.findIndex((k) => k.name === 'smid') + 1];

  const dockedPatientJacketKeys: Array<any> = [];
  const dockedPatientJacketRegexp = pathToRegexp(
    AppRoutePath.PATIENT_JACKET,
    dockedPatientJacketKeys
  );
  const dockedPatientJacketMatch = dockedPatientJacketRegexp.exec(path);
  const dockedPatientJacketId =
    dockedPatientJacketMatch?.[dockedPatientJacketKeys.findIndex((k) => k.name === 'smid') + 1];

  const id = viewerId ?? reporterId ?? undockedPatientJacketId ?? dockedPatientJacketId;
  return id != null && id !== NOT_FOUND_CASE_ID ? [id] : [];
};

const useWorklistId = (): Nullable<string> => {
  const matchViewer = useMatch(AppRoutePath.VIEWER);
  const matchReporter = useMatch({ path: AppRoutePath.REPORTER, end: false });
  const matchAISandbox = useMatch(AppRoutePath.AI_SANDBOX);
  const matchPatientJacket = useMatch(AppRoutePath.PATIENT_JACKET);
  const matchUndockedPatientJacket = useMatch(AppRoutePath.PATIENT_JACKET_UNDOCKED);
  const matchWard = getWARDCaseId();
  const worklistId =
    matchViewer?.params?.worklistId ??
    matchReporter?.params?.worklistId ??
    matchAISandbox?.params?.worklistId ??
    matchPatientJacket?.params?.smid ??
    matchUndockedPatientJacket?.params?.smid ??
    matchWard ??
    '';

  const smid = useMemo(() => {
    return worklistId.length > 0 && worklistId !== 'undefined' ? worklistId : null;
  }, [worklistId]);

  return smid;
};

export default useWorklistId;
